import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="page-filter"
export default class extends Controller {
  static targets = ["input", "item"]

  filter() {
    const query = this.inputTarget.value.toLowerCase().trim()

    this.itemTargets.forEach((item) => {
      const text = item.textContent.toLowerCase()
      item.style.display = text.includes(query) ? "" : "none"
    })
  }

  clear() {
    this.inputTarget.value = ""
    this.itemTargets.forEach((item) => {
      item.style.display = ""
    })
  }
}
